import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice } from '../../../helpers'

const CommissionList = ({
  loading,
  commissions,
  page,
  totalPages,
  setPage
}) => {
  return (
    <div className="cover-card-produk">
      <h2 className="judul">Riwayat komisi</h2>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px 0', color: '#666' }}>
          Memuat data komisi...
        </div>
      ) : commissions.length === 0 ? (
        <div className="btn-bayar" style={{ minHeight: '500px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <p style={{ textAlign: 'center', marginBottom: '15px', color: '#888' }}>Belum ada riwayat komisi.</p>
        </div>
      ) : (
        commissions.map((item, index) => {
          const formattedDate = new Date(item.created_at || item.createdAt).toLocaleDateString('id-ID', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })

          return (
            <div
              key={item.id || index}
              style={{ border: '1px solid rgba(0, 0, 0, 0.08)', borderRadius: '8px', padding: '12px 16px', backgroundColor: '#fff', marginBottom: '10px' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <p className="judul" style={{ margin: 0, fontWeight: 'bold', color: (item.type === 'debit' && item.withdrawal?.status === 2) ? '#e53935' : '#00a651', textTransform: 'uppercase' }}>
                    {item.description || (item.transaction?.code ? `Transaksi #${item.transaction.code}` : `Komisi #${item.id}`)}
                  </p>
                  <span style={{ fontSize: '0.85em', color: '#777' }}>
                    {formattedDate}
                  </span>
                </div>
                <div style={{ textAlign: 'right' }}>
                  {(() => {
                    let prefix = ''
                    let color = '#00a651'
                    if (item.type === 'credit') {
                      prefix = '+'
                      color = '#00a651'
                    } else if (item.type === 'debit') {
                      const wStatus = item.withdrawal?.status
                      if (wStatus === 1) {
                        prefix = '-'
                        color = '#e53935'
                      } else {
                        prefix = ''
                        color = '#222'
                      }
                    }
                    return (
                      <p className="harga" style={{ margin: 0, fontSize: '1.1em', fontWeight: '800', color }}>
                        {prefix} {formatPrice(item.fee || item.amount, 'Rp.')}
                      </p>
                    )
                  })()}
                </div>
              </div>

              {item.transaction && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #f5f5f5', fontSize: '0.85em', color: '#555' }}>
                  <span>Total Transaksi: <strong>{formatPrice(item.transaction.total, 'Rp.')}</strong></span>
                </div>
              )}
            </div>
          )
        })
      )}

      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '20px', marginBottom: '10px' }}>
          <button
            disabled={page <= 1}
            onClick={() => setPage(p => Math.max(p - 1, 1))}
            style={{
              padding: '8px 16px',
              borderRadius: '6px',
              border: '1px solid #00a651',
              background: page <= 1 ? '#eee' : '#fff',
              color: page <= 1 ? '#999' : '#00a651',
              fontWeight: 'bold',
              cursor: page <= 1 ? 'not-allowed' : 'pointer',
              outline: 'none'
            }}
          >
            Sebelumnya
          </button>
          <span style={{ fontSize: '0.9em', color: '#555' }}>
            Halaman {page} dari {totalPages}
          </span>
          <button
            disabled={page >= totalPages}
            onClick={() => setPage(p => Math.min(p + 1, totalPages))}
            style={{
              padding: '8px 16px',
              borderRadius: '6px',
              border: '1px solid #00a651',
              background: page >= totalPages ? '#eee' : '#00a651',
              color: page >= totalPages ? '#999' : '#fff',
              fontWeight: 'bold',
              cursor: page >= totalPages ? 'not-allowed' : 'pointer',
              outline: 'none'
            }}
          >
            Selanjutnya
          </button>
        </div>
      )}
    </div>
  )
}

CommissionList.propTypes = {
  loading: PropTypes.bool.isRequired,
  commissions: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired
}

export default CommissionList
